import api from './authService';

const CACHE_KEY = 'platform_settlement_currency_v1';
const CACHE_TTL_MS = 60 * 1000;

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.data || !parsed?.cachedAt) return null;
    if (Date.now() - parsed.cachedAt > CACHE_TTL_MS) return null;
    return parsed.data;
  } catch {
    return null;
  }
}

function writeCache(data) {
  try {
    sessionStorage.setItem(
      CACHE_KEY,
      JSON.stringify({ data, cachedAt: Date.now() })
    );
  } catch {
    // ignore
  }
}

export function clearSettlementCurrencyCache() {
  try {
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Public settlement currency for checkout / money UI (Strategy A).
 */
export async function getPlatformSettlementCurrency({ force = false } = {}) {
  if (!force) {
    const cached = readCache();
    if (cached?.currency) return cached;
  }

  const response = await api.get('/platform/settlement-currency');
  const data = response.data?.data || response.data;
  if (data?.currency) writeCache(data);
  return data;
}

export const adminSettlementSettingsService = {
  get: async () => {
    const response = await api.get('/admin/settlement-settings');
    return response.data;
  },

  save: async (payload) => {
    const response = await api.put('/admin/settlement-settings', payload);
    clearSettlementCurrencyCache();
    return response.data;
  },
};

export default {
  getPlatformSettlementCurrency,
  clearSettlementCurrencyCache,
  adminSettlementSettingsService,
};
